"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalContext = void 0;
var _react = require("react");
const PortalContext = /*#__PURE__*/(0, _react.createContext)({
  addNode: () => {},
  removeNode: () => {},
  nodes: []
});
exports.PortalContext = PortalContext;